export class PricesheetItem {
  id: number;
  pricesheet_id: number;
  name: string;
  unit_price: number;
  unit_type: string;
  quantity: number;
  journey_step_id: number;
  journey_path_id: number | null;
  journey_path_name: string | null;
  step_price: number;
  estimated_roi: number | null;
  sequence: number;
  conversion_rule_text: string;
  description: string;
  is_mandatory: boolean;
  has_dependency: boolean;
  is_supplemental: boolean;
  create_date: string | null;
  /** FK to the (step, dimension) cell this item prices. Null = step default. */
  journey_step_dimension_id: number | null;
  /** Display name of the JSD (resolved by the read schema); null for default cell. */
  journey_step_dimension_name: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.pricesheet_id = data.pricesheet_id;
    this.name = data.name;
    this.unit_price = data.unit_price;
    this.unit_type = data.unit_type;
    this.quantity = data.quantity ?? 1;
    this.journey_step_id = data.journey_step_id;
    this.journey_path_id = data.journey_path_id ?? null;
    this.journey_path_name = data.journey_path_name ?? null;
    this.step_price = data.step_price ?? 0;
    this.estimated_roi = data.estimated_roi ?? null;
    this.sequence = data.sequence ?? 0;
    this.conversion_rule_text = data.conversion_rule_text ?? "";
    this.description = data.description ?? "";
    this.is_mandatory = data.is_mandatory ?? false;
    this.has_dependency = data.has_dependency ?? false;
    this.is_supplemental = data.is_supplemental ?? false;
    this.create_date = data.create_date ?? null;
    this.journey_step_dimension_id = data.journey_step_dimension_id ?? null;
    this.journey_step_dimension_name = data.journey_step_dimension_name ?? null;
  }
}